import * as B from '../block'
import {MarkdownAdmin, defaultConfig, migrate} from './admin'

export const MarkdownBlock = B.blockWithInfo(
  {
    name: 'blurb',
    displayName: 'MarkdownBlock',
    title: 'Markdown',
    Admin: MarkdownAdmin,
    defaultConfig,
    migrate,
  },
  ({config: {container, heading, message, background, justification}}) => {
    const html = B.useMarkdown(message) || ''
    const content =
      message.trim() && html.trim() ?
        <B.TextContainer
          variant={container}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: B.flexAlign(justification),
            textAlign: justification,
          }}
        >
          {heading && <B.Section.Heading>{heading}</B.Section.Heading>}
          <B.Html html={html} variant="dangerous" reset />
        </B.TextContainer>
      : null

    return (
      <B.Scene>
        {content && <B.Background content={content} background={background} />}
      </B.Scene>
    )
  },
)
